import Vue from 'vue';

import waiting from '@/components/Waiting'
import AsDialogo from '@/components/AsDialogo.vue';
import AsDatePickerMenu from '@/components/AsDatePickerMenu.vue';
import AsTimePicker from '@/components/AsTimePicker.vue';
import AsCampoValor from '@/components/AsCampoValor.vue';
import AsLoadVideo from '@/components/AsLoadVideo.vue';


Vue.component('waiting', waiting);
Vue.component('AsDialogo', AsDialogo);
Vue.component('AsDatePickerMenu', AsDatePickerMenu);
Vue.component('AsTimePicker', AsTimePicker);
Vue.component('AsCampoValor', AsCampoValor);
Vue.component('AsLoadVideo', AsLoadVideo);
